





















































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { ExternalService } from '@/types/user'
import { isCordovaEnvironment } from '@/utils/cordova'
import ky from 'ky'
import { METHODS } from '@/external/api/types'
import { signonUrl } from '@/external/util'

@Component
export default class LoginModal extends Vue {
  @Prop({ default: {} }) service!: ExternalService
  $store!: ExStore
  showSwitching = false
  showLogin = false
  externalUsername = ''
  externalPassword = ''
  loginError: string | null = null
  error: string | null = null
  token = localStorage.getItem('token') || ''

  get userInfo() {
    return this.$store.getters['user/userInfo']
  }

  get serviceMethod() {
    return this.service.method as keyof METHODS
  }

  created() {
    this.checkUserExist()
  }

  async checkUserExist() {
    this.showSwitching = false
    this.showLogin = false
    try {
      this.error = null
      const res = await this.$exapi[this.serviceMethod].exist({
        endpoint: this.service.apiBaseUrl,
        heartlinePk: this.userInfo.id
      })
      if (res.username) {
        this.externalUsername = res.username
        this.showSwitching = true
      } else {
        this.showLogin = true
      }
    } catch (e) {
      if (e instanceof ky.HTTPError) {
        this.showLogin = true
        return
      }
      console.error(e)
      this.error = e
    }
  }

  async loginExternalService() {
    if (!this.externalUsername || !this.externalPassword) {
      this.loginError = 'ユーザー名とパスワードは必須です'
      return
    }
    try {
      this.loginError = null
      this.error = null
      const res = await this.$exapi[this.serviceMethod].login({
        username: this.externalUsername,
        password: this.externalPassword,
        endpoint: this.service.apiBaseUrl,
        heartlinePk: this.userInfo.id,
        accessToken: this.token
      })
      if (!('id' in res)) {
        throw new Error('ログインエラー')
      }
      this.openExternalService()
    } catch (e) {
      if (e instanceof ky.HTTPError) {
        const res = await e.response.json()
        this.loginError = res.message[0]
        return
      }
      console.error(e)
      this.error = e
    }
  }

  async openExternalService() {
    const url = signonUrl({
      endpoint: this.service.apiBaseUrl,
      heartlinePk: this.userInfo.id,
      accessToken: this.token
    })
    if (isCordovaEnvironment()) {
      this.$postMessage.openExternalUrl(url)
    } else {
      window.open(url, '_blank')
    }
    this.$emit('close')
  }
}
